/**
 * Marketing attribution source code mapping.
 * Maps short URL codes (?ref=xx) to human-readable source names.
 *
 * Canonical data lives in marketingSources.json — this module
 * re-exports it with TypeScript typing for frontend consumers.
 *
 * Also imported by tools/create-marketing-links.ts (via the .json directly).
 */
import sourceCodes from './marketingSources.json';

export const SOURCE_CODES: Record<string, string> = sourceCodes;
